export const barConfig = {
  type: "bar",
  seriesLayoutBy: "row",
  barWidth: "20%",
}

export const emptyConfig = {
  type: "text",
  left: "center",
  top: "middle",
  silent: true,
  style: {
    fill: "rgba(255,255,255, .6)",
    fontWeight: "bold",
    text: "暂无数据",
    fontFamily: "Microsoft YaHei",
    fontSize: "14px",
  },
}

export default {
  color: ["rgba(43, 151, 247, 1)", "rgba(234, 202, 65, 1)"],
  grid: {
    right: 10,
    bottom: "10%",
    top: "18%",
    left: "20px",
    containLabel: true,
  },
  dataset: {
    source: [],
  },
  legend: {
    show: true,
    data: [],
    top: "7px",
    right: 10,
    textStyle: {
      color: "#FFFFFFA6",
      height: 18,
    },
    icon: "rect",
    itemHiehgt: 5,
    itemWidth: 15,
  },
  xAxis: {
    type: "category",
    axisLine: {
      lineStyle: {
        color: "#FFFFFFA6",
      },
    },
    axisLabel: {
      interval: 0,
      rotate: 0,
    },
  },
  yAxis: {
    name: "",
    axisLine: {
      lineStyle: {
        color: "#FFFFFFA6",
      },
    },
    splitLine: {
      lineStyle: {
        color: "rgba(255, 255, 255, .2)",
        type: "dashed",
      },
    },
  },
  series: [],
  graphic: [{}],
}
